<template>
  <DefaultLoader v-if="isLoading"></DefaultLoader>
  <div v-else class="page-content">
    <div class="top-section">
      <a
        class="back-button"
        @click="
          $router.options.history.state.back
            ? $router.back()
            : $router.push({
                name: 'backup-request'
              })
        "
        ><i class="bi bi-arrow-left"></i> Back</a
      >
      <h5 class="page-heading">Backup Trip Details</h5>
    </div>
    <div class="card partner-card">
      <div class="card-header">TR Summary</div>
      <div class="card-body">
        <div class="row cell-row">
          <div class="cell w-25">
            <h6>Route</h6>
            <p>
              {{
                backupRequestData.route_name
                  ? backupRequestData.route_name
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Type</h6>
            <p>
              {{
                backupRequestData.service_type
                  ? backupRequestData.service_type
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Backup Time</h6>
            <p>
              {{
                backupRequestData.backup_time
                  ? backupRequestData.backup_time
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Distance</h6>
            <p
              v-if="
                backupRequestData.tripRequestRoute &&
                backupRequestData.tripRequestRoute.distance
              "
            >
              {{ backupRequestData.tripRequestRoute.distance }} KM
            </p>
            <p
              v-else-if="
                backupRequestData.tripRequest &&
                backupRequestData.tripRequest.distance
              "
            >
              {{ backupRequestData.tripRequest.distance }} KM
            </p>
            <p v-else>N/A</p>
          </div>
        </div>
        <div class="row cell-row">
          <div class="cell w-25">
            <h6>Backup Reason</h6>
            <p>
              {{
                backupRequestData.reason_for_backup
                  ? backupRequestData.reason_for_backup
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Driver Informed</h6>
            <p>
              {{
                backupRequestData.driver_informed
                  ? backupRequestData.driver_informed
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Existing Driver Name</h6>
            <p>
              {{
                driverDetails[backupRequestData.old_driver_code]
                  ? driverDetails[backupRequestData.old_driver_code].name
                  : 'N/A'
              }}
            </p>
          </div>
          <div class="cell w-25">
            <h6>Existing Driver Mobile</h6>
            <p>
              {{
                driverDetails[backupRequestData.old_driver_code]
                  ? driverDetails[backupRequestData.old_driver_code].mobile
                  : 'N/A'
              }}
            </p>
          </div>
        </div>
        <div v-if="backupRequestData.tripRequestRoute" class="row cell-row">
          <div class="cell w-25">
            <h6>Points</h6>
            <p>
              <!-- <span
                class="partner-hyperlink"
                @click="
                  vehicleRequest.redirectToMap(
                    backupRequestData.tripRequestRoute
                  )
                "
                >See Map</span
              > -->
              <span
                class="partner-hyperlink"
                data-bs-toggle="modal"
                data-bs-target="#mapModal"
                >See Map</span
              >
            </p>
          </div>
          <div class="cell w-25">
            <h6>See Original TR</h6>
            <p>
              <router-link
                class="partner-hyperlink"
                :to="`/trip-request/vehicle-request/details/${backupRequestData.tripRequestRoute.trip_requests_id}/${backupRequestData.tripRequestRoute.id}`"
                ><i class="bi bi-box-arrow-up-right"></i
              ></router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editBackupPrice" class="card partner-card">
      <div class="card-header">Edit Backup Price</div>
      <form @submit.prevent="updateBackupPrice">
        <div class="card-body">
          <div class="partner-form">
            <div class="row">
              <div class="col-md-4">
                <label for="">Backup Price</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="formValue.backup_price"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer" style="display: flex; justify-content: end">
          <button
            type="button"
            class="btn btn-cancel"
            @click="editBackupPrice = false"
          >
            Cancel
          </button>
          <button class="btn btn-primary">Update</button>
        </div>
      </form>
    </div>
    <div v-else class="card partner-card">
      <div class="card-header">
        Backup Price
        <div class="button-area">
          <span class="edit-button" @click="editBackupPrice = true">
            <i class="bi bi-pencil-square"></i>
          </span>
        </div>
      </div>
      <div class="card-body">
        <div class="row cell-row">
          <div class="cell w-25">
            <h6>Backup Price</h6>
            <p>
              {{
                backupRequestData.backup_price
                  ? backupRequestData.backup_price + ' TK'
                  : 'N/A'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card partner-card"
      v-if="
        backupRequestData.inviteDrivers?.length > 0 ||
        backupRequestData.tripHideReson?.length > 0
      "
    >
      <div
        class="card-header"
        v-if="
          backupRequestData.inviteDrivers?.length > 0 &&
          backupRequestData.tripHideReson?.length > 0
        "
      >
        <ul class="nav backup-nav">
          <li class="nav-item">
            <a
              :class="{
                'nav-link': true,
                active: driverSectionActiveTab === 'driver_info'
              }"
              aria-current="page"
              @click="driverSectionActiveTab = 'driver_info'"
              >Driver Info</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="{
                'nav-link': true,
                active: driverSectionActiveTab === 'trip_hide_reason'
              }"
              @click="driverSectionActiveTab = 'trip_hide_reason'"
              >Trip Hide Reason</a
            >
          </li>
        </ul>
      </div>
      <div
        class="card-header"
        v-else-if="backupRequestData.tripHideReson?.length > 0"
      >
        Trip Hide Reason
      </div>
      <div class="card-header" v-else>Driver Info</div>
      <div class="card-body table-responsive">
        <table
          class="table partner-table"
          v-if="driverSectionActiveTab === 'driver_info'"
        >
          <thead>
            <tr>
              <th>SL</th>
              <th>Name</th>
              <th>Phone No.</th>
              <th>Vehicle Type</th>
              <th>Garage Location</th>
              <th>Price</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(driver, index) in backupRequestData.inviteDrivers"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ driverDetails[driver.partner_id]?.name }}</td>
              <td>{{ driverDetails[driver.partner_id]?.mobile }}</td>
              <td>
                {{
                  driver.car_info?.car_type?.name
                    ? driver.car_info.car_type.name
                    : 'N/A'
                }}
              </td>
              <td>
                {{
                  driver.driver_info?.garage_location?.name
                    ? driver.driver_info.garage_location.name
                    : 'N/A'
                }}
              </td>
              <td>{{ driver.price }}</td>
              <td>
                <span class="partner-badge partner-badge-pink rounded-pill">{{
                  driver.status
                }}</span>
                <span
                  v-if="driver.trip_cancel_reason"
                  class="partner-hyperlink"
                  style="margin-left: 10px"
                  data-bs-toggle="modal"
                  data-bs-target="#tripCancelReasonModal"
                  @click="selectedBackupDriver = driver"
                  >Cancel Reason</span
                >
              </td>
              <td>
                <button
                  v-if="
                    driver.status !== 'Assigned' &&
                    backupRequestData.backup_status !== 'Cancelled' &&
                    backupRequestData.backup_status !== 'Completed' &&
                    partnerStatCount('Assigned') <= 0
                  "
                  class="btn btn-xs btn-primary"
                  @click="assignDriver(driver)"
                >
                  Assign
                </button>
                <button
                  v-if="driver.status === 'Assigned'"
                  class="btn btn-xs btn-secondary"
                  @click="unAssignDriver(driver)"
                >
                  Unassign
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-else-if="driverSectionActiveTab === 'trip_hide_reason'"
          class="table partner-table"
        >
          <thead>
            <tr>
              <th>SL</th>
              <th>Reason</th>
              <th>Remarks</th>
              <th>Remark By Name</th>
              <th>Remark By Mobile</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(reason, index) in backupRequestData.tripHideReson"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ reason.reason }}</td>
              <td>{{ reason.remark }}</td>
              <td>
                {{
                  reason.remark_by
                    ? driverDetails[reason.remark_by]
                      ? driverDetails[reason.remark_by].name
                      : reason.remark_by
                    : 'N/A'
                }}
              </td>
              <td>
                {{
                  reason.remark_by
                    ? driverDetails[reason.remark_by]
                      ? driverDetails[reason.remark_by].mobile
                      : reason.remark_by
                    : 'N/A'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-if="
        partnerStatCount('Assigned') <= 0 &&
        backupRequestData.backup_status !== 'Cancelled' &&
        backupRequestData.backup_status !== 'Completed'
      "
      class="card partner-card"
      id="assignDriver"
    >
      <div class="card-body">
        <div class="no-driver-portion">
          <img src="../../assets/icon/sadIcon.png" alt="Sad Icon" />
          <h4>No driver is assigned yet!</h4>
          <p>This backup TR doesn’t have any driver assigned.</p>
          <button
            class="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#assignDriverToBackupTripModal"
          >
            Assign Driver
          </button>
          <button
            style="margin-left: 10px"
            class="btn btn-primary"
            @click="searchDriverForBackupRoute"
          >
            Search Driver
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Assign driver to backup TR modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="assignDriverToBackupTripModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <AssignDriverToBackupTrip
          :backupTrip="backupRequestData"
          @refreshData="getBackupRequest()"
        ></AssignDriverToBackupTrip>
      </div>
    </div>
  </teleport>

  <!-- Map Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="mapModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Map</h5>
            <button
              ref="modalCloseBtn"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            <DirectionMap
              :mapData="backupRequestData.tripRequestRoute?.route_map"
            ></DirectionMap>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Trip cancel reason modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="tripCancelReasonModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <TripCancelReason :driver="selectedBackupDriver"></TripCancelReason>
      </div>
    </div>
  </teleport>
</template>

<script>
import http from '../../config/axios';
import userServiceAPI from '../../store/userServiceAPI';
import { vehicleRequest } from '../../store/vehicleRequest/vehicleRequest';
import { backupRequest } from '../../store/backupRequest/backupRequest';
import AssignDriverToBackupTrip from '../tripRequest/AssignDriverToBackupTrip.vue';
import DirectionMap from '../tripRequest/map/DirectionMap.vue';
import TripCancelReason from './TripCancelReason.vue';

export default {
  components: {
    AssignDriverToBackupTrip,
    DirectionMap,
    TripCancelReason
  },
  data() {
    return {
      isLoading: false,
      backupRequestData: {},
      driverDetails: {},
      editBackupPrice: false,
      formValue: {
        route_id: null,
        backup_price: null
      },
      driverSectionActiveTab: 'driver_info',
      selectedBackupDriver: null,
      vehicleRequest,
      backupRequest
    };
  },
  mounted() {
    this.getBackupRequest();
  },
  methods: {
    initFormValue() {
      this.editBackupPrice = false;
      this.formValue.route_id = this.backupRequestData.route_id;
      this.formValue.backup_price = this.backupRequestData.backup_price;
    },
    async mapAllDriverDetails() {
      let partnerIds = [];
      if (this.backupRequestData?.old_driver_code) {
        partnerIds.push(this.backupRequestData.old_driver_code);
      }
      if (this.backupRequestData.inviteDrivers?.length > 0) {
        let invitedDriverIds = this.backupRequestData.inviteDrivers.map(
          (driver) => driver.partner_id
        );
        let tripHideReasonUserIds = this.backupRequestData.inviteDrivers.map(
          (reason) => reason.remark_by
        );
        partnerIds.push(invitedDriverIds);
        partnerIds.push(tripHideReasonUserIds);
      }
      await userServiceAPI.getUserDetails(partnerIds).then((res) => {
        this.driverDetails = {};
        this.driverDetails = userServiceAPI.mapUsersIntoObject(res.data?.data);
      });
    },
    selectDriverSectionTab() {
      if (this.backupRequestData.inviteDrivers?.length > 0) {
        this.driverSectionActiveTab = 'driver_info';
      } else if (this.backupRequestData.tripHideReson?.length > 0) {
        this.driverSectionActiveTab = 'trip_hide_reason';
      }
    },
    getBackupRequest() {
      this.isLoading = true;
      http
        .get(
          `v2/partners/backup/request/${this.$route.params.id}/${this.$route.params.route_id}/show`
        )
        .then(async (response) => {
          this.backupRequestData = response.data.data;
          // Get users info from User Service
          await this.mapAllDriverDetails();
          this.initFormValue();
          this.selectDriverSectionTab();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response?.data?.message
          });
        });
    },
    partnerStatCount(status) {
      let count = 0;

      if (this.backupRequestData.inviteDrivers) {
        this.backupRequestData.inviteDrivers.forEach((driver) => {
          if (driver.status === status) {
            count++;
          }
        });
      }

      return count;
    },
    assignDriver(driver) {
      this.$partnerSwal.confirmationAlert
        .fire({
          title: 'Are you sure?',
          text: 'You are assigning this driver to this backup TR!'
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            http
              .post(`/v2/partners/backup/invite/drivers/trips/status`, {
                id: driver.id,
                driver_code: driver.partner_id,
                backup_request_id: driver.backup_request_id,
                status: 'Assigned',
                trip_id: this.backupRequestData?.trip_id
              })
              .then(
                (response) => {
                  this.isLoading = false;
                  if (response.status === 200) {
                    this.$partnerSwal.quickSuccessAlert.fire({
                      title: 'Congratulations!',
                      text: response.data?.message
                    });
                    this.getBackupRequest();
                  }
                },
                (error) => {
                  this.isLoading = false;
                  this.$partnerSwal.errorToast.fire({
                    title: 'Error!',
                    text: error.response?.data?.message
                  });
                }
              );
          }
        });
    },
    unAssignDriver(driver) {
      this.$partnerSwal.confirmationAlert
        .fire({
          title: 'Are you sure?',
          text: 'You want to unassign this driver from this backup TR!'
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            http
              .post(`/v2/partners/backup/invite/drivers/trips/status`, {
                id: driver.id,
                driver_code: driver.partner_id,
                backup_request_id: driver.backup_request_id,
                status: 'Unassigned',
                trip_id: this.backupRequestData?.trip_id
              })
              .then(
                (response) => {
                  this.isLoading = false;
                  if (response.status === 200) {
                    this.$partnerSwal.quickSuccessAlert.fire({
                      title: 'Congratulations!',
                      text: response.data?.message
                    });
                    this.getBackupRequest();
                  }
                },
                (error) => {
                  this.isLoading = false;
                  this.$partnerSwal.errorToast.fire({
                    title: 'Error!',
                    text: error.response?.data?.message
                  });
                }
              );
          }
        });
    },
    searchDriverForBackupRoute() {
      let price = backupRequest.calculatePriceFromTripRequest(
        this.backupRequestData.tripRequestRoute
          ? this.backupRequestData.tripRequestRoute
          : this.backupRequestData.tripRequest
      );
      let selectedTR = [
        {
          id: this.backupRequestData.id,
          trip_id: this.backupRequestData.trip_id,
          trip_request_id: this.backupRequestData.trip_request_id,
          backup_request_code: this.backupRequestData.backup_request_code,
          route_name: this.backupRequestData.route_name,
          price: price
        }
      ];
      localStorage.setItem('selectedBackupTR', JSON.stringify(selectedTR));
      this.$router.push('/trip-request/partner-location-list');
    },
    updateBackupPrice() {
      this.isLoading = true;
      http
        .put(
          `v2/partners/backup/request/update/${this.backupRequestData.id}`,
          this.formValue
        )
        .then((response) => {
          this.isLoading = false;
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success!',
            text: response.data?.message
          });
          this.getBackupRequest();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response?.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.back-button {
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  margin-left: 15px;
  margin-bottom: 6px;
}
.page-heading {
  margin: 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #121212;
}
.partner-nav-holder {
  overflow: hidden;
}
.partner-card {
  margin-top: 24px;
}
.cell-row {
}
.cell-row:first-child .cell {
  margin-top: 0;
}
.cell {
  float: left;
  margin-top: 28px;
}
.cell h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 4px;
}
.cell p {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0;
}

.no-driver-portion {
  text-align: center;
  color: #949494;
}
.no-driver-portion img {
  width: 43px;
  margin-bottom: 23px;
}
.no-driver-portion h4 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 0;
}
.no-driver-portion p {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}
.no-driver-portion .btn {
  padding: 9px 56px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}
.sub-heading {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 14px !important;
  margin-bottom: 6px !important;
}
.highlighted-text {
  font-weight: 600 !important;
  color: #652f8f;
}
.modality {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #a95eea;
  background: rgba(169, 94, 234, 0.1);
  border: 1px solid #a95eea;
  border-radius: 24px;
  padding: 8px 12px;
}

.unassign-driver-btn {
  color: #fff;
}

.edit-button {
  cursor: pointer;
  color: #652f8f;
}
.edit-button:hover {
  cursor: pointer;
  color: #a95eea;
}

.backup-nav {
}
.backup-nav .nav-item {
  margin-right: 1rem;
}
.backup-nav .nav-link {
  padding: 0;
  cursor: pointer;
  color: #000;
}
.backup-nav .nav-link:hover {
  color: #a95eea;
}
.backup-nav .active {
  color: #652f8f;
  font-weight: bold;
}
.backup-nav .active:hover {
  color: #652f8f;
}

.w-37 {
  width: 37% !important;
}
.w-21 {
  width: 21% !important;
}
.w-25 {
  width: 25%;
}
@media only screen and (max-width: 768px) {
  .w-37 {
    width: 100% !important;
  }
  .w-21 {
    width: 100% !important;
  }
  .w-25 {
    width: 100% !important;
  }
}
</style>
